/* Small entry point: no cart API request, app bundle or recommendation fetch on page load. */
(() => {
  const configNode = document.getElementById('kr-native-cart-config');
  if (!configNode || window.KrystalCart) return;
  const config = JSON.parse(configNode.textContent);
  let loaded;
  const load = () => loaded ||= Promise.all([
    import(config.moduleUrl),
    new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = config.cssUrl;
      const timeout = setTimeout(() => { css.remove(); reject(new Error('Kurvens design tog for lang tid at indlæse.')); }, 12000);
      css.onload = () => { clearTimeout(timeout); resolve(); };
      css.onerror = () => { clearTimeout(timeout); css.remove(); reject(new Error('Kurvens design kunne ikke indlæses.')); };
      document.head.append(css);
    })
  ]).then(([module]) => module.createCart(config)).catch(error => { loaded = null; throw error; });
  window.KrystalCart = {
    open: trigger => load().then(cart => cart.open(trigger)),
    refresh: () => loaded ? loaded.then(cart => cart.refresh()) : Promise.resolve(),
    add: data => load().then(cart => cart.add(data))
  };
  window.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a.kr-header__icon-cart, a.header__icon--cart, a[data-kr-cart-open]');
    if (!link || link.target === '_blank') return;
    event.preventDefault(); event.stopImmediatePropagation();
    load().then(cart => cart.open(link)).catch(() => { window.location.assign(config.cartUrl); });
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.krCartSubmitting === 'true') return;
    form.dataset.krCartSubmitting = 'true';
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const data = new FormData(form);
    const extras = form.closest('product-form')
      ? Array.from(document.querySelectorAll('#kr-upsell-widget .kr-upsell__checkbox:checked')).map(input => input.value) : [];
    const wasDisabled = submitter?.disabled;
    if (submitter) { submitter.disabled = true; submitter.setAttribute('aria-busy', 'true'); }
    // Loading failure occurs BEFORE a cart mutation: only then is native form fallback safe.
    load().then(cart => cart.addForm(data, extras, submitter), () => {
      if (submitter) submitter.disabled = wasDisabled;
      if (!extras.length) HTMLFormElement.prototype.submit.call(form);
      else {
        // Never silently drop selected add-ons in a native, main-product-only fallback.
        let notice = form.querySelector('[data-kr-cart-load-error]');
        if (!notice) { notice = document.createElement('p'); notice.dataset.krCartLoadError = ''; notice.setAttribute('role','alert'); form.append(notice); }
        notice.textContent = 'Kurven kunne ikke indlæses. Ingen varer er tilføjet. Prøv igen, så dine valgte tilkøb også kommer med.';
      }
    }).finally(() => {
      delete form.dataset.krCartSubmitting;
      if (submitter) { submitter.disabled = wasDisabled; submitter.removeAttribute('aria-busy'); }
    });
  }, true);
  document.addEventListener('cart:refresh', () => { if (loaded) loaded.then(cart => cart.refresh()); });
  window.addEventListener('pageshow', event => { if (event.persisted && loaded) loaded.then(cart => cart.refresh()); });
})();
